<script>
import DialogBody from "../../../dialog/components/dialog-body.vue";
import DialogActionbar from "../../../dialog/components/dialog-actionbar.vue";
import DialogHeader from "../../../dialog/components/dialog-header.vue";
import API from "../../../../API";
import Loading from "../../../common/loading.vue";
import DialogBase from "../../../dialog/components/dialog-base.vue";
import User from "../../user/data/User";
import TextField from "../../../common/text-field.vue";
import toaster from "../../../common/toaster";


export default {
    name: "myuser-totp-dialog",
    components: {TextField, DialogBase, Loading, DialogHeader, DialogActionbar, DialogBody},
    props: {
        showDialog: {
            type: Boolean,
            required: true
        },
        user: {
            type: User,
            required: true
        }
    },
    data: vm => {
        return {
            loading: false,
            setupCompleted: false,
            seedString: undefined,
            seedQr: undefined,
            code: undefined,
            recoveryCodes: undefined,

            tDescription: Lang.langGet("These are a set of ONE TIME USE codes that can be used instead of the Two Factor Authentication. Make sure you store them somewhere safe."),
            tConfirmationError: Lang.langGet("Confirmation failed! Please check your devices timezone or start the setup again."),
            tTitle: Lang.langGet('Setup Two Factor Authentication'),
            tEnterCode: Lang.langGet('Please enter your authentication code'),
            tWarning: Lang.langGet('You already have two factor authentication. Proceeding will replace your old two factor authentication!')


        };
    },
    methods: {
        handleClose() {
            this.$emit('cancel', this.setupCompleted);
        },
        async handleSave() {
            this.loading = true;
            const url = '/totp/auth'
            const api = new API(url);
            const data = {code: this.code};

            const response = await api.post(data, this.handleError);

            if (!response.errored) {
                await this.loadRecoveryCodes();
            }

            this.loading = false;
        },
        async loadRecoveryCodes() {
            const url = '/totp/recovery-codes';
            const api = new API(url);
            const codes = await api.get();

            if (!codes.errored) {
                this.recoveryCodes = codes;
                this.setupCompleted = true;
            }
        },
        async loadQrCode() {
            this.loading = true;
            this.recoveryCodes = undefined;
            this.code = undefined;
            this.setupCompleted = false;

            const url = '/totp/prepare';
            const api = new API(url);

            const data = await api.get(url);

            this.loading = false;

            if (!data.errored) {
                this.seedString = data.seedString;
                this.seedQr = data.seedQr;
            }
        },
        handleError() {
            const message = this.tConfirmationError;
            toaster.error(message);
        },
        async copySeedToClipboard() {
            if (!navigator.clipboard) {
                toaster.error(Lang.langGet('Could not copy to clipboard.'));
                console.error(Lang.langGet('Clipboard is undefined - are you in a secure context?'));
             } else {
                navigator.clipboard.writeText(this.seedString).then(() => {
                    toaster.success(Lang.langGet('Seed copied to clipboard.'));
                }).catch(() => {
                    toaster.error(Lang.langGet('Could not copy to clipboard.'));
                });
            }
        }
    },
    watch: {
        showDialog: function(newShowDialog) {
            if (newShowDialog) {
                this.loadQrCode();
            }
        }
    },
    mounted() {
        this.loadQrCode();
    }
}
</script>

<template>
    <dialog-base
        :maxWidth="640"
        :showDialog="showDialog"
        @close="handleClose"
    >
        <loading :loading="loading" />
        <v-card>
            <dialog-header
                :title="tTitle"
                @close="handleClose"
            />
            <dialog-body class="mx-3">
                <div v-if="!recoveryCodes" class="d-flex flex-row justify-space-between mt-4">
                    <div class="d-flex flex-column flex-grow-1 align-center">
                        <div class="d-flex flex-row w-100">
                            <text-field
                                disabled
                                class="w-100"
                                label="Seed"
                                v-model="seedString"
                            />
                            <div class="d-flex align-center pl-2">
                                <i class="fa-regular fa-copy fa-fw fa-xl cursor-pointer" @click="copySeedToClipboard"/>
                            </div>
                        </div>
                        <text-field
                            autofocus
                            type="number"
                            class="w-100 mt-4"
                            placeholder="123456"
                            label="Authentication code"
                            :hint="tEnterCode"
                            v-model="code"
                        />
                    </div>
                    <div class="d-flex flex-column align-center ml-4">
                        <div v-if="!loading" v-html="seedQr"/>
                    </div>
                </div>
                <h4 v-if="user.totpActive" class="text-center">{{ tWarning }}</h4>
                <div v-if="recoveryCodes" class="d-flex flex-column mt-4">
                    <h4 class="text-center">{{ tDescription }}</h4>
                    <div v-for="code in recoveryCodes" class="mx-8">
                        {{code}}
                    </div>
                </div>
            </dialog-body>
            <dialog-actionbar
                @close="handleClose"
                @save="handleSave"
                :disableSave="!code || setupCompleted"
            >
            </dialog-actionbar>
        </v-card>
    </dialog-base>
</template>

<style scoped>
    .w-100 {
        width: 100%;
    }
</style>
